import Cookies from 'js-cookie';

const getGtmDatalayer = () => {
	const gtmEnvironment =
		location.host === 'www.aifsabroad.com' ? 'production' : 'staging';
	const currentDate = new Date().toLocaleString('en-US', {
		timeZone: 'America/New_York',
	});
	const isInternalNetwork = false;
	const gtmApplicationStatus =
		Cookies.get('College-GTM-applicationStatus') || false;
	const gtmConsultStatus = Cookies.get('College-GTM-consultstatus') || false;
	const gtmContactId = Cookies.get('College-GTM-userid') || false;
	const gtmRifStatus = Cookies.get('College-GTM-rifstatus') || false;
	const titleElement = document.getElementsByTagName('title')[0];

	return {
		environment: gtmEnvironment,
		dataLayer: [
			{
				'site.environment': gtmEnvironment,
				visitor: {
					isLoggedIn: false,
					applicationStatus: gtmApplicationStatus,
					consultStatus: gtmConsultStatus,
					userId: gtmContactId,
					rifStatus: gtmRifStatus,
					isInternalNetworkRequest: isInternalNetwork,
				},
				page: {
					title: titleElement.textContent,
					serverTime: currentDate,
					program: '',
				},
			},
		],
	};
};

export default getGtmDatalayer;
